'use client';
import BottomSheet from '@/shared/ui/bottom-sheet';
import { Box, Button, Input, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { Dispatch } from 'react';

export interface IPropsComment {
  comment: { comment: string; isOpen: boolean };
  setComment: Dispatch<
    React.SetStateAction<{ comment: string; isOpen: boolean }>
  >;
  onOpenChange: () => void;
  handleSaveComment: () => void;
}

const AddComment = ({
  onOpenChange,
  handleSaveComment,
  setComment,
  comment,
}: IPropsComment) => {
  const t = useTranslations();
  return (
    <BottomSheet isOpen={comment.isOpen} onClose={onOpenChange}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSaveComment();
        }}
      >
        <Text color={'text'} px={4} fontSize="xl" fontWeight="bold">
          {t('comment_to_product')}
        </Text>
        <Box p={4}>
          <Input
            onChange={(e) =>
              setComment((prevState) => ({
                ...prevState,
                comment: e.target.value,
              }))
            }
            value={comment.comment}
            size="xl"
            h={'56px'}
            name="comment"
            border={'none'}
            outline={'none'}
            rounded={16}
            placeholder={t('comment')}
            variant={'subtle'}
            color={'text'}
            bgColor={'background'}
          />
        </Box>
        <Box p={4}>
          <Button
            bg="primary"
            color="primary.text"
            _hover={{ bg: 'primary.hover' }}
            w={'full'}
            size={'xl'}
            h={'56px'}
            rounded={16}
            mb="28px"
            onClick={handleSaveComment}
            disabled={!Boolean(comment?.comment)}
          >
            {t('ready')}
          </Button>
        </Box>
      </form>
    </BottomSheet>
  );
};

export default AddComment;
